// 为了兼容ssjlicai.com, feidee.com等多域名，需要取到当前页面访问地址的一级域名
import url from '@common/url'

export const DOMAIN_ENV = {
  LOCAL: 'local',
  DEV: 'dev',
  TEST: 'test',
  UAT: 'uat',
  PROD: 'prod',
  OUTER_PROD: 'outer_prod',
}

class Domain {
  /**
   * @param {string} domain 域名
   * @param {string} env 环境，仅供单元测试用
   */
  constructor({ domain, env } = { domain: url('domain'), env: '' }) {
    this.env = env
    this.domain = domain
    this.ip = ''
    this.domainUrl = {
      res: '',
      api: '',
      actapi: '',
      mkt: '',
      pc: '',
      collect: '',
      loan: '',
    }
    this.init()
  }
  init() {
    let env = this.env
    let domainUrlConfig
    if (!env) {
      const hostname = location.hostname
      const isProd = /^marketres/.test(hostname)
      const isOuterProd = /^tg/.test(hostname)
      const isUat = /^lcuatres/.test(hostname)
      const isTest = /^lctsres/.test(hostname)
      const isDev = /^devpub/.test(hostname)
      if (isOuterProd) {
        env = DOMAIN_ENV.OUTER_PROD
      } else if (isProd) {
        env = DOMAIN_ENV.PROD
      } else if (isUat) {
        env = DOMAIN_ENV.UAT
        domainUrlConfig = { uat: /^lcuatres(\d*)\./.exec(hostname)[1] }
      } else if (isTest) {
        env = DOMAIN_ENV.TEST
        domainUrlConfig = { test: /^lctsres(\d+)\./.exec(hostname)[1] }
      } else if (isDev) {
        env = DOMAIN_ENV.DEV
      } else {
        if (/^localhost/.test(hostname)) {
          this.ip = 'localhost'
        } else if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(hostname)) {
          this.ip = hostname
        } else {
          console.warn('@common/domain：未知的环境！')
        }
        env = DOMAIN_ENV.LOCAL
      }
      this.env = env
    }
    this.setDomainUrl(this.getDomainUrl(env, domainUrlConfig))
  }
  getDomainUrl(env, options = { test: '1', uat: '' }) {
    switch (env) {
      case DOMAIN_ENV.OUTER_PROD:
        return {
          res: `https://tg.${this.domain}`,
          api: `https://moneymarket.${this.domain}`,
          actapi: `https://act.${this.domain}`,
          mkt: `https://moneymarket.${this.domain}`,
          pc: `https://8.${this.domain}`,
          collect: `https://dataapi.${this.domain}`,
          loan: `https://sxd.${this.domain}`,
        }
      case DOMAIN_ENV.PROD:
        return {
          res: `https://marketres.${this.domain}`,
          api: `https://moneymarket.${this.domain}`,
          actapi: `https://act.${this.domain}`,
          mkt: `https://moneymarket.${this.domain}`,
          pc: `https://8.${this.domain}`,
          collect: `https://dataapi.${this.domain}`,
          loan: `https://sxd.${this.domain}`,
        }
      case DOMAIN_ENV.UAT:
        return {
          res: `https://lcuatres${options.uat}.${this.domain}`,
          api: `https://lcuat${options.uat}.${this.domain}`,
          actapi: `https://actuat.${this.domain}`,
          mkt: `https://lcuat.${this.domain}`,
          pc: `https://lcuatweb.${this.domain}/market-mobi`,
          collect: `https://dataapi.${this.domain}`,
          loan: `https://lcuat${options.uat}.${this.domain}`,
        }
      case DOMAIN_ENV.TEST:
        return {
          res: `https://lctsres${options.test}.${this.domain}`,
          api: `https://lcts${options.test}.${this.domain}`,
          actapi: `https://act${options.test}.${this.domain}`,
          mkt: `https://lcts${options.test}.${this.domain}`,
          pc: `https://lcts${options.test}.${this.domain}/p2pmarket`,
          collect: `https://lcts5.${this.domain}`,
          loan: `https://lcts${options.test}.${this.domain}`,
        }
      case DOMAIN_ENV.DEV:
        return {
          res: `https://devpub.${this.domain}`,
          api: `https://devpub.${this.domain}`,
          actapi: `https://act.${this.domain}`,
          mkt: `https://devpub.${this.domain}`,
          pc: `https://devpcweb.${this.domain}/p2pmarket`,
          collect: `https://lcts5.${this.domain}`,
          loan: `https://devpub.${this.domain}`,
        }
      case DOMAIN_ENV.LOCAL:
        return {
          res: `http://${this.ip}`,
          api: `http://${this.ip}:8090`,
          actapi: `http://${this.ip}:8090`,
          mkt: `http://${this.ip}`,
          pc: 'https://8.ssjlicai.com',
          collect: `http://${this.ip}:8090`,
          loan: `http://${this.ip}:8090`,
        }
      default:
        return {}
    }
  }
  setDomainUrl(domainUrl) {
    Object.keys(this.domainUrl).forEach((item) => {
      if (domainUrl[item]) {
        this.domainUrl[item] = domainUrl[item]
      }
    })
  }
  setDomain(domain) {
    const tmpDomain = this.domain
    this.domain = domain
    Object.keys(this.domainUrl).forEach((item) => {
      this.domainUrl[item] = this.domainUrl[item].replace(tmpDomain, domain)
    })
  }
  /**
   * 手动设置当前环境，仅供单元测试用
   *
   * @param {string} env
   * @memberof Domain
   */
  setDomainEnv(env) {
    this.env = env
    this.domain = 'ssjlicai.com'
    if (env === DOMAIN_ENV.LOCAL) {
      this.ip = '1.2.3.4'
    }
    this.init()
  }
}

let domain = null

export const getInstance = () => {
  if (!domain) {
    domain = new Domain()
  }
  return domain
}
// 自定义hostname
export const setHostName = (host) => {
  getInstance().setDomain(host)
}

// 设置所有的hostname
export const setAllHostName = (hostMap) => {
  getInstance().setDomainUrl(hostMap)
}

export default getInstance().domainUrl



// WEBPACK FOOTER //
// ./node_modules/@finance/ssvue/node_modules/@common/domain/src/index.js